/**
 * 所有缓存的键值枚举
 */
export enum LOCAL_STORAGE_KEYS {
    // 语言
    'LANGUAGE' = 'LANGUAGE',
    // 账号信息
    'ACCOUNT' = 'ACCOUNT',
    // TOKEN信息
    'TOKEN' = 'TOKEN',
    // 服务器地址
    'SERVER_URL' = 'SERVER_URL',
    // 服务器地址列表
    'SERVER_URLS' = 'SERVER_URLS',
    // 呼叫服务
    'CALL_SERVICE' = 'CALL_SERVICE',
    // google map 密钥
    'MAPS_KEY' = 'MAPS_KEY',
    // 默认餐厅
    'DEFAULT_RESTAURANT' = 'DEFAULT_RESTAURANT',
    // RBP 餐厅的国家
    'RBP_RESTAURANT_COUNTRY' = 'RBP_RESTAURANT_COUNTRY',
    // RBP 餐厅的货币
    'RBP_RESTAURANT_CURRENCY' = 'RBP_RESTAURANT_CURRENCY',
    /** DIS 设置页：小票打印重试次数本地缓存（与 RBP2 一致） */
    'DIS_SETTING_PRINT_RETRY_NUM' = 'DIS_SETTING_PRINT_RETRY_NUM',
}